import { gql } from "@apollo/client";

export const getOrganicStats = gql`
    query getOrganicStats(
        $granularity: ReportingGranularity
        $fieldsList: [OrganicStatsFieldInput!]
        $assetType: MyLensesAssetType
        $lensId: ID
        $startTime: GoogleProtobufTimestampInput
        $endTime: GoogleProtobufTimestampInput
        $breakdownAssetType: MyLensesAssetType
        $sortBy: MetricField
        $sortDirection: ReportingSortDirection
        $limit: Int
    ) {
        getMyLensesOrganicStats(
            input: {
                limit: $limit
                granularity: $granularity
                assetType: $assetType
                fieldsList: $fieldsList
                startTime: $startTime
                endTime: $endTime
                lensId: $lensId
                breakdownAssetType: $breakdownAssetType
                sortBy: $sortBy
                sortDirection: $sortDirection
            }
        ) {
            responseEntryList {
                assetId
                assetType
                statsResponseTimeEntryList {
                    timestamp {
                        nanos
                        seconds
                    }
                    statsList {
                        field {
                            fieldName
                            reportDimension
                        }
                        statsList {
                            value
                            dimensionBreakdown
                        }
                    }
                }
            }
        }
    }
`;
